// External
import { signOut } from "../../Firebase/FirebaseAuth";
import { auth } from "../../Firebase/InitFirebase";
import { useEffect, useState } from "react";

// Local 
import frog from "../../Images/frog.png"
import NavBar from "../../Universal Components/NavBar/NavBar"
import { getCurrentUserSubscriptionStatus } from "../../Stripe/StripeFunctions";
import SubscriberProfile from "./SubscriberProfile";
import NonSubscriberProfile from "./NonSubscriberProfile";

// CSS
import "./Profile.css"



export default function Profile(){
    
    const [subscription_status, set_subscription_status] = useState(null);
    const [first_active_subscription_found, set_first_active_subscription_found] = useState(null);


    const user = auth.currentUser;  

    useEffect(() => {
        const fetchSubscription = async () => {
        let subscriptionStatus =  await getCurrentUserSubscriptionStatus(); 
          set_subscription_status(subscriptionStatus);
        };
        fetchSubscription()
    }, []);
      

    // Find first active subscription, usually should be only 1, I THINK. But could end up with more. Also if a user has had a subscription previously this will find the active one.
    useEffect(() => {
        if(subscription_status == null) return;
        for(let i=0; i<subscription_status.length; i++){
            if(subscription_status[i]?.status === "active"){
                set_first_active_subscription_found(subscription_status[i])
                break
            }
        }
    },[subscription_status])


    




    return(
        <>
            <NavBar/>

            <div className="profile-page">
                
                <div className="profile-info-container">
                    <div className="profile-image">
                            <img src={frog} className="frog" alt="forggie"/>
                    </div>
                                        
                    <div className="user-display-name">
                        {user.displayName}
                    </div>

                    <div className="datum-wrapper">
                        <div>
                            User Since:
                        </div>
                        <div className="account-datum">
                            {user.metadata.creationTime}
                        </div>
                    </div>

                    <div className="datum-wrapper">
                        <div>
                            Email:
                        </div>
                        <div className="account-datum">
                            {user.email}
                        </div>
                    </div>

                    <button className="sign-out-button" onClick={() => signOut()}>
                        Sign Out
                    </button>
                </div>
                
                <div className="other-profile-info-container">
                    {subscription_status === null ? null : (
                        first_active_subscription_found === null
                        ? <NonSubscriberProfile />
                        : <SubscriberProfile firstActiveSubscriptionFound={first_active_subscription_found} />
                    )}
                </div>



            </div>
        </>
        
    )
}